import '$lib/i18n';
import { locale as lang } from 'svelte-i18n';
import type { PageLoad } from '../$types';


export const load = (async ({ url, data }) => {
	const locale = url.pathname.split('/')[1];
	lang.set(locale);
	return {
		...data,
		locale
	}
}) satisfies PageLoad;
